import type {PublicMethodUtils} from '@wix/document-services-types'
import type {EditorFeaturesPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<EditorFeaturesPublicAPI> {
    const {
        extensionPublicAPI: {getter, immediate}
    } = publicMethodUtils

    return {
        methods: {
            editorFeatures: {
                instances: {
                    list: immediate('editorFeatures.instances.list'),
                    create: immediate('editorFeatures.instances.create')
                },
                data: {
                    getPointer: getter('editorFeatures.data.getPointer'),
                    listPointers: getter('editorFeatures.data.listPointers'),
                    get: immediate('editorFeatures.data.get'),
                    remove: immediate('editorFeatures.data.remove'),
                    update: immediate('editorFeatures.data.update')
                }
            }
        }
    }
}
